const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* כותרת ראשית */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#9a624b] via-[#ac609c] to-[#9a624b] bg-clip-text text-transparent mb-4">
            תנאי שימוש
          </h1>
          <p className="text-gray-600 text-xl">
            תנאי השימוש באתר SHA-SHA Jewelry
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#9a624b] to-[#ac609c] mx-auto rounded-full mt-6"></div>
        </div>

        {/* מבוא */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">מבוא</h2>
          <div className="space-y-4 text-gray-700">
            <p className="leading-relaxed">
              ברוכים הבאים לאתר SHA-SHA Jewelry. השימוש באתר זה כפוף לתנאי השימוש המפורטים להלן.
              השימוש באתר מהווה הסכמה לתנאים אלה.
            </p>
            <p className="leading-relaxed">
              SHA-SHA Jewelry היא חנות תכשיטים מקוונת המנוהלת על ידי נטלי בדש.
              אנו מתמחים בתכשיטים בעבודת יד עם אבנים טבעיות.
            </p>
          </div>
        </div>

        {/* הזמנות ותשלומים */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">הזמנות ותשלומים</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">תהליך ההזמנה</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>בחירת מוצרים והוספתם לעגלת הקניות</li>
                <li>מלא פרטי משלוח ותשלום</li>
                <li>אישור ההזמנה וקבלת אישור באימייל</li>
                <li>עיבוד ההזמנה ומשלוח המוצרים</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">אפשרויות תשלום</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>כרטיסי אשראי (כל הסוגים)</li>
                <li>PayPal (בקרוב)</li>
                <li>תשלום בטלפון</li>
                <li>העברה בנקאית (בתאום מראש)</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">מחירים</h3>
              <p className="leading-relaxed">
                כל המחירים באתר כוללים מע״מ. אנו שומרים לעצמנו את הזכות לשנות מחירים בכל עת.
                המחיר החייב הוא המחיר בעת ביצוע ההזמנה.
              </p>
            </div>
          </div>
        </div>

        {/* פרטיות ואבטחה */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">פרטיות ואבטחה</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">איסוף מידע</h3>
              <p className="leading-relaxed">
                אנו אוספים מידע אישי לצורך עיבוד הזמנות, שירות לקוחות ושיפור השירות.
                המידע נשמר בצורה מאובטחת ולא יועבר לצדדים שלישיים ללא אישור.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">אבטחת מידע</h3>
              <p className="leading-relaxed">
                האתר מוגן באמצעות SSL והתשלומים מתבצעים דרך מערכות מאובטחות.
                אנו נוקטים בכל האמצעים הנדרשים להגנה על פרטיותכם.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">Cookies</h3>
              <p className="leading-relaxed">
                האתר משתמש ב-Cookies לשיפור חוויית המשתמש ולניתוח ביצועים.
                ניתן לבטל את השימוש ב-Cookies בהגדרות הדפדפן.
              </p>
            </div>
          </div>
        </div>

        {/* הגבלת אחריות */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">הגבלת אחריות</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">איכות מוצרים</h3>
              <p className="leading-relaxed">
                אנו מתחייבים לאיכות המוצרים שלנו ומספקים אחריות על פגמים.
                במקרה של פגם, נחליף את המוצר או נחזיר את הכסף.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">זמינות מוצרים</h3>
              <p className="leading-relaxed">
                אנו שומרים לעצמנו את הזכות לשנות או לבטל מוצרים בכל עת.
                במקרה של ביטול מוצר, נחזיר את הכסף במלואו.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">שירות האתר</h3>
              <p className="leading-relaxed">
                אנו מתחייבים לספק שירות אמין, אך איננו אחראים לבעיות טכניות זמניות.
                נשתדל לפתור בעיות במהירות האפשרית.
              </p>
            </div>
          </div>
        </div>

        {/* זכויות יוצרים */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">זכויות יוצרים</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">תוכן האתר</h3>
              <p className="leading-relaxed">
                כל התוכן באתר, כולל תמונות, טקסטים ועיצובים, מוגן בזכויות יוצרים.
                אסור להעתיק, להפיץ או להשתמש בתוכן ללא אישור.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">עיצובים ייחודיים</h3>
              <p className="leading-relaxed">
                כל התכשיטים שלנו הם בעבודת יד ועיצובים ייחודיים.
                אסור להעתיק או לשכפל עיצובים ללא אישור.
              </p>
            </div>
          </div>
        </div>

        {/* שינויים בתנאים */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">שינויים בתנאים</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">עדכון תנאים</h3>
              <p className="leading-relaxed">
                אנו שומרים לעצמנו את הזכות לעדכן את תנאי השימוש בכל עת.
                שינויים ייכנסו לתוקף עם פרסומם באתר.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">הודעה על שינויים</h3>
              <p className="leading-relaxed">
                במקרה של שינויים משמעותיים, נשלח הודעה למייל הרשום.
                המשך השימוש באתר מהווה הסכמה לתנאים המעודכנים.
              </p>
            </div>
          </div>
        </div>

        {/* יצירת קשר */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">צריכים עזרה?</h2>
          <div className="grid md:grid-cols-2 gap-8 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">פרטי קשר</h3>
              <div className="space-y-3">
                <p><strong>טלפון:</strong> 053-3332127</p>
                <p><strong>אימייל:</strong> nataly@sha-sha.co.il</p>
                <p><strong>שעות פעילות:</strong> א׳-ה׳ 09:00-19:00, ו׳ 09:00-14:00</p>
              </div>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">מידע נוסף</h3>
              <div className="space-y-3">
                <p>• תנאים אלה נכנסו לתוקף ב-1.1.2025</p>
                <p>• עדכון אחרון: 1.1.2025</p>
                <p>• גרסה: 1.0</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage; 